(function () {
  'use strict';

  function normalizePath(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.origin !== window.location.origin) return '';
      var path = parsed.pathname.replace(/\/+$/, '') || '/';
      return path.toLowerCase();
    } catch (error) {
      return '';
    }
  }

  function init(root) {
    if (!root || root.dataset.searchV2FinalReady === 'true') return;
    root.dataset.searchV2FinalReady = 'true';

    var destinationsSection = root.querySelector('[data-search-v2-destinations]');
    var destinationsList = root.querySelector('[data-search-v2-destinations-list]');
    var productsSection = root.querySelector('[data-search-v2-products]');
    var productsList = root.querySelector('[data-search-v2-products-list]');
    if (!destinationsList || !productsList) return;

    var allowedCollections = new Set();
    root.querySelectorAll('[data-search-v2-active-collection]').forEach(function (node) {
      var normalized = normalizePath(node.getAttribute('data-search-v2-active-collection'));
      if (normalized) allowedCollections.add(normalized);
    });

    var destinationObserver = null;

    function refineResults() {
      if (destinationObserver) destinationObserver.disconnect();

      var cards = Array.prototype.slice.call(destinationsList.children);
      var brand = cards.find(function (card) {
        return card.getAttribute('data-search-v2-result-type') === 'brand';
      }) || null;
      var collection = cards.find(function (card) {
        if (card.getAttribute('data-search-v2-result-type') !== 'collection') return false;
        var path = normalizePath(card.getAttribute('href'));
        return path && allowedCollections.has(path);
      }) || null;

      var keep = [];
      if (brand) keep.push(brand);
      if (collection) keep.push(collection);

      cards.forEach(function (card) {
        if (keep.indexOf(card) === -1) card.remove();
      });
      keep.forEach(function (card, index) {
        if (destinationsList.children[index] !== card) {
          destinationsList.insertBefore(card, destinationsList.children[index] || null);
        }
      });

      if (destinationsSection) destinationsSection.hidden = keep.length === 0;
      if (productsSection) productsSection.hidden = productsList.childElementCount === 0;
      root.setAttribute('data-search-v2-destination-count', String(keep.length));

      if (destinationObserver) destinationObserver.observe(destinationsList, { childList: true });
    }

    destinationObserver = new MutationObserver(refineResults);
    destinationObserver.observe(destinationsList, { childList: true });

    var productObserver = new MutationObserver(function () {
      if (productsSection) productsSection.hidden = productsList.childElementCount === 0;
    });
    productObserver.observe(productsList, { childList: true });

    refineResults();
  }

  document.querySelectorAll('[data-search-v2]').forEach(init);
})();
